'use client';

import { FC, MouseEvent } from 'react';

import { Button, useData } from '@/components';
import { useUiStore } from '@/data';

import style from './ChooseStoreButton.module.scss';

const ChooseStoreButton: FC = () => {
  const [, setUiState] = useUiStore();
  const { productCard } = useData();

  const buttonText = productCard?.checkAvilibility || 'Choose your Store';

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    setUiState({ is_store_location_open: true });
  };

  return (
    <div className={style.choose_store}>
      <Button
        ariaLabel={buttonText}
        className={style.button}
        color="primary"
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export { ChooseStoreButton };
